<app-dashboard-sidemenu></app-dashboard-sidemenu>

<div class="main-content d-flex flex-column">

  <app-dashboard-navbar></app-dashboard-navbar>

  <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
    <h1>{{Content.title}}</h1>
    <ol class="breadcrumb">
      <li class="item"><a routerLink="/">Home</a></li>
      <li class="item"><a routerLink="/dashboard">{{Content.subTitle}}</a></li>
      <li class="item">{{Content.title}}</li>
    </ol>
  </div>

  <form [formGroup]="ASNform" (ngSubmit)="onSubmit()" #asnform="ngForm">
    <div class="add-listings-box1">

      <!-- Items Table -->
      <div class="table-scroll-container mb-3 shadow-sm rounded"
        style="max-height: 38vh; overflow: auto; border: 1px solid #dee2e6;">
        <table class="table table-bordered asnlist mb-0">
          <thead>
            <tr>
              <th>Po No.</th>
              <th>Item Number</th>
              <th>Item Description</th>
              <th>Order Date</th>
              <th>Req Date</th>
              <th>Del Date</th>
              <th>Open Qty</th>
              <th>Rem Qty</th>
              <th>Value Stream</th>
              <th>Price</th>
              <th>Ship Qty<span class="star_class">*</span></th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody formArrayName="items">
            <tr *ngFor="let item of items.controls; let i = index" [formGroupName]="i">
              <td style="width: 90px;"><input type="text" formControlName="id" readonly
                  style="border: none; width: 90px; background: transparent;"></td>
              <td style="width: 100px;"><input type="text" formControlName="itemNumber" readonly
                  style="border: none; width: 100px; background: transparent;"></td>
              <td><input type="text" formControlName="itemDesc" readonly
                  style="border: none; width: 100%; background: transparent;"></td>
              <td style="width: 90px;"><input type="text" formControlName="orderDate"
                  [value]="orderDate?.value | date:'dd-MM-yy'" readonly
                  style="width: 90px; border: none; background: transparent;"></td>
              <td style="width: 90px;"><input type="text" formControlName="requestedDate"
                  [value]="requestedDate?.value | date:'dd-MM-yy'" readonly
                  style="width: 90px; border: none; background: transparent;"></td>
              <td style="width: 90px;"><input type="text" formControlName="schPickDate"
                  [value]="promisedDeliveryDate?.value | date:'dd-MM-yy'" readonly
                  style="width: 90px; border: none; background: transparent;"></td>
              <td style="width: 65px;"><input type="text" formControlName="quantityOpen" readonly
                  style="border: none; width: 65px; background: transparent;"></td>
              <td style="width: 65px;"><input type="text" readonly formControlName="asnRemainingQuantity"
                  style="border: none; width: 65px; background: transparent;"></td>
              <td style="width: 100px;"><input type="text" formControlName="valueStream2" readonly
                  style="border: none; width: 100px; background: transparent;"></td>
              <td style="width: 90px;"><input type="text" formControlName="unitPrice" readonly
                  style="border: none; width: 90px; background: transparent;"></td>
              <td style="width: 110px;">
                <input type="text" formControlName="ship"
                  style="border: 1px solid #ced4da; border-radius: 5px; width: 110px; padding: 3px 6px;"
                  (keypress)="keyPress($event)" maxlength="5" placeholder="Enter Ship Qty"
                  [class.is-invalid]="asnform.submitted && item.get('ship')?.invalid || item.get('ship')?.touched && item.get('ship')?.invalid" />
                <div class="error"
                  *ngIf="asnform.submitted && item.get('ship')?.invalid || item.get('ship')?.touched && item.get('ship')?.invalid">
                  Please enter a Ship value
                </div>
                <div class="error" *ngIf="item.errors?.shipExceedsOpen">
                  Ship qty cannot exceed Available qty.
                </div>
              </td>
              <td style="width: 100px;"><input type="text" formControlName="shipAmount" readonly
                  style="border: none; width: 100px; background: transparent; font-weight: 600;"
                  [value]="(item.get('shipAmount')?.value | number:'1.0-2') || ''"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Financial Summary + Invoice Fields Row -->
      <div class="row align-items-start mt-3 px-1">

        <!-- Invoice Number & Date -->
        <div class="col-lg-7">
          <div class="row p-3 shadow-sm mx-0"
            style="background: rgba(248, 249, 250, 0.6); border: 1px solid #edf2f7; border-radius: 8px;">
            <div class="col-lg-6 col-md-12 form-group mb-0">
              <label class="d-block mb-2"
                style="color: #495057; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">
                Invoice Number<span class="star_class text-danger">*</span>
              </label>
              <input type="text" class="form-control shadow-sm" formControlName="invoice_num"
                placeholder="Enter Invoice Number"
                style="border-radius: 6px; border: 1px solid #ced4da; padding: 8px; background-color: #fff;"
                [class.is-invalid]="asnform.submitted && ASNform.get('invoice_num')?.invalid || ASNform.get('invoice_num')?.touched && ASNform.get('invoice_num')?.invalid">
              <div class="error"
                *ngIf="asnform.submitted && ASNform.get('invoice_num')?.invalid || ASNform.get('invoice_num')?.touched && ASNform.get('invoice_num')?.invalid">
                Please enter Invoice Number
              </div>
            </div>
            <div class="col-lg-6 col-md-12 form-group mb-0">
              <label class="d-block mb-2"
                style="color: #495057; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">
                Invoice Date<span class="star_class text-danger">*</span>
              </label>
              <p-calendar formControlName="InvoiceDate" placeholder="Select Invoice Date" [maxDate]="today"
                [readonlyInput]="true" [showIcon]="true"
                [class.is-invalid]="asnform.submitted && ASNform.get('InvoiceDate')?.invalid || ASNform.get('InvoiceDate')?.invalid && ASNform.get('InvoiceDate')?.touched">
              </p-calendar>
              <div class="invalid-feedback">Please Select Date</div>
            </div>
          </div>
        </div>

        <!-- Financial Summary Card -->
        <div class="col-lg-5 d-flex justify-content-end form-group mb-0">
          <div class="shadow-sm w-100"
            style="background: linear-gradient(145deg, #ffffff, #f8fafc); border-radius: 10px; border: 1px solid #e2e8f0; max-width: 360px; overflow: hidden;">
            <div style="background-color: #f1f5f9; padding: 10px 15px; border-bottom: 1px solid #e2e8f0;">
              <strong style="color: #475569; font-size: 13px; text-transform: uppercase;">Financial Summary</strong>
            </div>
            <div class="p-3">
              <div class="d-flex justify-content-between mb-2" style="font-size: 14px;">
                <span style="color: #64748b; font-weight: 500;">Value (Excl. Tax):</span>
                <span style="font-weight: 600; ">{{ calculateTotalShipAmount() | number:'1.2-2' }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2" style="font-size: 14px;">
                <span style="color: #64748b; font-weight: 500;">Tax Amount:</span>
                <span style="font-weight: 600;">+ {{ calculateTotalTaxAmount() | number:'1.2-2' }}</span>
              </div>
              <div style="border-top: 1px dashed #cbd5e1; margin: 12px 0;"></div>
              <div class="d-flex justify-content-between align-items-center">
                <strong style="font-size: 15px; color: #1e293b;">Total (Incl. Tax):</strong>
                <strong style="font-size: 18px; color: #10b981;">{{ calculateTotalAmountWithTax() | number:'1.2-2'
                  }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Attach Documents Section -->
      <div class="row mt-4 px-1">
        <div class="col-12 mb-3">
          <div
            style="background-color: #f1f5f9; padding: 10px 15px; border-radius: 8px 8px 0 0; border-bottom: 1px solid #e2e8f0; border: 1px solid #e2e8f0; border-radius: 8px;">
            <strong style="color: #475569; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px;">Attach
              Documents</strong>
          </div>
        </div>

        <!-- Invoice -->
        <div class="col-lg-3 col-md-6 form-group mb-3">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">
            Invoice<span class="star_class text-danger">*</span>
          </label>
          <input type="file" class="form-control shadow-sm" (change)="uploadDoc($event,'invoice')"
            style="border-radius: 6px; padding: 5px;">
          <div *ngIf="selectedData[0]?.invoicePath" class="mt-2">
            <a [href]="selectedData[0]?.invoicePath" target="_blank"
              class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center shadow-sm"
              style="border-radius: 6px; padding: 6px; font-size: 12px; gap: 6px;">
              <i class="bx bx-file"></i> Preview Current
            </a>
          </div>
          <div class="error"
            *ngIf="asnform.submitted && ASNform.get('invoice_doc')?.invalid || ASNform.get('invoice_doc')?.invalid && ASNform.get('invoice_doc')?.touched">
            Please select Invoice Document
          </div>
        </div>

        <!-- Delivery Challan -->
        <div class="col-lg-3 col-md-6 form-group mb-3">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">
            Delivery Challan<span class="star_class text-danger">*</span>
          </label>
          <input type="file" class="form-control shadow-sm" (change)="uploadDoc($event,'delivery')"
            style="border-radius: 6px; padding: 5px;">
          <div *ngIf="selectedData[0]?.deliveryChaalanPath" class="mt-2">
            <a [href]="selectedData[0]?.deliveryChaalanPath" target="_blank"
              class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center shadow-sm"
              style="border-radius: 6px; padding: 6px; font-size: 12px; gap: 6px;">
              <i class="bx bx-file"></i> Preview Current
            </a>
          </div>
          <div class="error"
            *ngIf="asnform.submitted && ASNform.get('delivery_doc')?.invalid || ASNform.get('delivery_doc')?.invalid && ASNform.get('delivery_doc')?.touched">
            Please select Delivery Document
          </div>
        </div>

        <!-- Eway Bill -->
        <div class="col-lg-3 col-md-6 form-group mb-3">
          <label class="d-block mb-2"
            style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">
            Eway Bill
          </label>
          <input type="file" class="form-control shadow-sm" (change)="uploadDoc($event,'eway')"
            style="border-radius: 6px; padding: 5px;">
          <div *ngIf="selectedData[0]?.ewayBillPath" class="mt-2">
            <a [href]="selectedData[0]?.ewayBillPath" target="_blank"
              class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center shadow-sm"
              style="border-radius: 6px; padding: 6px; font-size: 12px; gap: 6px;">
              <i class="bx bx-file"></i> Preview Current
            </a>
          </div>
          <div *ngIf="ewayErrorMsg" class="error">E-Way Bill is required.</div>
        </div>
      </div>

      <!-- Additional Documents -->
      <div class="row px-1 mb-3">
        <div class="col-12 d-flex align-items-center justify-content-between mb-2">
          <label class="mb-0"
            style="color: #475569; font-weight: 600; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px;">
            Additional Documents
          </label>
          <p-button type="button" icon="bx bx-plus" (click)="addDocRow('add',i)" iconPos="right" class="secondary-btn">
          </p-button>
        </div>
        <div formArrayName="docs" class="col-12">
          <div class="row my-2 align-items-end" *ngFor="let doc of getdocs().controls; index as i; last as last"
            [formGroupName]="i">
            <div class="col-lg-3 col-md-12 form-group mb-0">
              <label class="d-block mb-1"
                style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">
                Document Name<span class="star_class text-danger">*</span>
              </label>
              <select formControlName="fileName" class="form-control form-select shadow-sm"
                style="border-radius: 6px; border: 1px solid #ced4da;">
                <option value="">Select Document Name</option>
                <ng-container *ngFor="let document of documentList">
                  <option [value]="document.documentName">{{document.documentName}}</option>
                </ng-container>
              </select>
            </div>
            <div class="col-lg-3 col-md-12 form-group mb-0">
              <label class="d-block mb-1"
                style="color: #6c757d; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">
                Select File
              </label>
              <input type="file" class="form-control shadow-sm" (change)="uploadDoc($event,'add_doc',i)"
                style="border-radius: 6px; padding: 5px;">
            </div>
            <div class="col-auto d-flex mb-0 align-items-end">
              <p-button type="button" icon="bx bx-minus" (click)="addDocRow('delete', i)" iconPos="right"
                class="secondary-btn ms-2">
              </p-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="mt-3 pt-3 border-top d-flex justify-content-end align-items-center gap-3">
        <button type="button" class="btn btn-outline-secondary shadow-sm d-flex align-items-center gap-2"
          [routerLink]="['/jde-data-listing']"
          style="padding: 10px 30px; border-radius: 8px; font-weight: 600; transition: all 0.2s;">
          <i class="bx bx-arrow-back" style="font-size: 16px;"></i> Back
        </button>
        <button type="submit" class="btn btn-success shadow-sm d-flex align-items-center gap-2 text-white"
          style="background: linear-gradient(135deg, #10b981 0%, #059669 100%); border: none; padding: 10px 30px; border-radius: 8px; font-weight: 600; transition: all 0.2s;">
          <i class="bx bx-save" style="font-size: 16px;"></i> Save ASN
        </button>
      </div>

    </div>
  </form>

</div>